import { render } from "./ConfigPortlet.vue?vue&type=template&id=b09d4070&scoped=true"
import script from "./ConfigPortlet.vue?vue&type=script&lang=js"
export * from "./ConfigPortlet.vue?vue&type=script&lang=js"

import "./ConfigPortlet.vue?vue&type=style&index=0&id=b09d4070&scoped=true&lang=css"

import exportComponent from "/home/james/WebstormProjects/pvpconfigui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b09d4070"]])

export default __exports__